export default __webpack_public_path__ + "static/about1-6400aa58bb92eea6f6fec8a0a3562aca.png";